import _ from 'lodash'

export enum ConceptActivation {
	Active = 'active',
	Disabled = 'disabled',
	Hidden = 'hidden',
}

export const shouldPersist = (activation: ConceptActivation) => {
	return activation === ConceptActivation.Active
}

const activationValues: string[] = _.values(ConceptActivation)
export function isConceptActivation(value: string): value is ConceptActivation {
	return activationValues.includes(value)
}

export type ConceptActivationByCid = _.Dictionary<ConceptActivation>
